import { render, staticRenderFns } from "./PeriodSwitch.vue?vue&type=template&id=d5696008&scoped=true&"
import script from "./PeriodSwitch.vue?vue&type=script&lang=js&"
export * from "./PeriodSwitch.vue?vue&type=script&lang=js&"
import style0 from "./PeriodSwitch.vue?vue&type=style&index=0&id=d5696008&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5696008",
  null
  
)

export default component.exports